import { Component } from '@angular/core';
import { CoreSignalAwardEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Awards') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-coresignalaward-form',
    templateUrl: './coresignalaward.form.component.html'
})
export class CoreSignalAwardFormComponent extends BaseFormComponent {
    public record!: CoreSignalAwardEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

